export const ternary = <T, P>(condition: boolean, ifTruthy: T, ifFalsy: P) => {
  return condition ? ifTruthy : ifFalsy;
};
